import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Icon from '@algbra/ui/components/Icon/Icon'
import Permalink from '@algbra/ui/components/Permalink/Permalink'
import Whitespace, {
  WhitespaceProps,
} from '@algbra/ui/components/Whitespace/Whitespace'
import { getIconByName } from '@algbra/ui/icons'
import { resolveAsImage } from '@algbra/ui/resolvers'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import styles from './ProductFeatureBlockFullImage.module.scss'
import axios from 'axios'
import { VAlign } from '@algbra/ui/enums/align'
import {
  MEDIA_QUERY_MOBILE,
  useMediaQuery,
} from '@algbra/ui/hooks/useMediaQuery'

export type ZoneProductFeatureBlockFullImageProps = {
  __typename: 'StrapiGQL_ComponentZonesProductFeatureBlockFullImage'
  id: string
  featureBlockFullImageTitle: string
  description: string
  imageAlignment: string
  image: GatsbyResolvedAsset
  mobileImage: GatsbyResolvedAsset
  detailLinkUrl?: string
  detailLinkTitle?: string
  finePrint?: string
  finePrintIcon?: GatsbyResolvedAsset
  logoImage?: GatsbyResolvedAsset
}

export default function ZoneProductFeatureBlockFullImage({
  id,
  featureBlockFullImageTitle,
  description,
  imageAlignment,
  image,
  mobileImage,
  detailLinkUrl,
  detailLinkTitle,
  finePrint,
  finePrintIcon,
  logoImage,
}: ZoneProductFeatureBlockFullImageProps): JSX.Element {
  const isMobile = useMediaQuery(MEDIA_QUERY_MOBILE)

  return (
    <Whitespace type="md" className={styles.whitespace}>
      <Row
        className={classNames(
          styles.container,
          styles[`imageAlignment__${imageAlignment}`]
        )}
        style={{
          backgroundImage: isMobile
            ? `url(${mobileImage.resolved.publicURL})`
            : `url(${image.resolved.publicURL})`,
        }}
      >
        <Container>
          <Row vAlign={VAlign.CENTER} className={styles.row}>
            <Column auto className={styles.contentCol}>
              <div className={styles.content}>
                {logoImage && (
                  <GatsbyImage
                    image={resolveAsImage(logoImage)}
                    alt={featureBlockFullImageTitle}
                    loading="lazy"
                    className={classNames(styles.logoImage)}
                  />
                )}
                <Heading type="lg" className={styles.title}>
                  {featureBlockFullImageTitle}
                </Heading>
                <FreeText
                  type="md"
                  color="white"
                  innerHTML={description}
                  className={styles.text}
                >
                  {description}
                </FreeText>
                {detailLinkTitle && (
                  <Permalink
                    to={detailLinkUrl}
                    className={styles.detailLinkContainer}
                  >
                    <FreeText
                      type="m"
                      color="white"
                      className={styles.detailLink}
                    >
                      {detailLinkTitle}
                    </FreeText>
                    <div className={styles.icon}>
                      <Icon icon={getIconByName('arrow-right')} size={24} />
                    </div>
                  </Permalink>
                )}
                {finePrint && (
                  <div className={styles.finePrintContainer}>
                    {finePrintIcon && (
                      <div
                        className={classNames(styles.finePrintIcon)}
                        style={{
                          backgroundImage:
                            finePrintIcon &&
                            `url(${finePrintIcon.resolved.publicURL})`,
                        }}
                      ></div>
                    )}

                    <FreeText className={styles.finePrint}>
                      {finePrint}
                    </FreeText>
                  </div>
                )}
              </div>
            </Column>
          </Row>
        </Container>
        {/* <Column className={classNames(styles.imageCol)}>
          <div className={classNames(styles.imagePlacement)}>
            <GatsbyImage
              image={resolveAsImage(image)}
              alt={featureBlockFullImageTitle}
              loading="lazy"
              className={classNames(styles.image)}
            />
          </div>
        </Column> */}
      </Row>
    </Whitespace>
  )
}
